import React from 'react';
const LogoutIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 3H16V17H13" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M10 10H3" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path d="M6 7L3 10L6 13" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default LogoutIcon;

